import React from "react";
import { Alert, AlertDescription } from "@lemonadetraining/web-ui";
import { IconInfoCircle } from "@tabler/icons-react";
import { formatCommitmentDate } from "@lemonadetraining/web-shared/utils/commitmentStatus";
import type { CardUpdateRedirect } from "../../hooks/useCardUpdateRedirect";
import CardUpdateButton from "./CardUpdateButton";
import CardUpdateError from "./CardUpdateError";
import { DUNNING_GRACE_BODY, DUNNING_GRACE_BODY_NO_DATE } from "./dunningCopy";

interface DunningBannerProps {
  graceEndsAt: Date | null;
  cardUpdate: CardUpdateRedirect;
  timeZone?: string | null;
  /** The gym's zone is still loading: say it without the date for now. */
  datesPending?: boolean;
}

/**
 * Grace: access is unaffected, so this is information, not a warning. The
 * body is legal copy and stays in the full-contrast foreground token.
 */
const DunningBanner: React.FC<DunningBannerProps> = ({
  graceEndsAt,
  cardUpdate,
  timeZone,
  datesPending,
}) => (
  <Alert variant="default" role="status" className="bg-muted" data-testid="dunning-grace">
    <IconInfoCircle aria-hidden="true" />
    <AlertDescription className="flex flex-col gap-3 text-foreground">
      <span>
        {graceEndsAt && !datesPending
          ? DUNNING_GRACE_BODY(formatCommitmentDate(graceEndsAt, timeZone))
          : DUNNING_GRACE_BODY_NO_DATE}
      </span>
      <div>
        <CardUpdateButton
          cardUpdate={cardUpdate}
          className="min-h-[44px] px-4"
          testId="dunning-grace-cta"
          showError={false}
        />
      </div>
      {cardUpdate.errorMessage ? (
        <CardUpdateError
          message={cardUpdate.errorMessage}
          onRetry={cardUpdate.start}
          busy={cardUpdate.status === "minting"}
        />
      ) : null}
    </AlertDescription>
  </Alert>
);

export default DunningBanner;
